import { memo } from "react";
import {
  DocumentStatus,
  getDocumentStatusesDisplayValue,
} from "../../types/DocumentStatuses";
import { Bubble } from "./Bubble";

type Props = {
  status?: DocumentStatus;
  /**
   * Override the text displayed in the bubble. By default, it is a display friendly version of the
   * DocumentStatus
   */
  text?: string;
};

import "../../styles/circles.css";

const DocumentStatusBubble = (props: Props) => {
  if (!props.status) {
    return null;
  }

  const statusText = getDocumentStatusesDisplayValue(props.status);

  let className = "";
  switch (props.status) {
    case "ERROR": {
      className = "warning";
      break;
    }
    case "UNKNOWN": {
      className = "error";
      break;
    }
    case "GENERAL": {
      className = "notification";
      break;
    }
    case "GENERAL_FORMAT": {
      className = "notification";
      break;
    }
    case "EMPTY": {
      className = "darkgreen";
      break;
    }
    case "MULTIPLE": {
      className = "orange";
      break;
    }
    case "INVALID": {
      className = "purple";
      break;
    }
  }

  return (
    <Bubble
      text={props.text ?? statusText}
      className={className}
      style={{ marginLeft: 5 }}
    />
  );
};
const MemoDocumentStatusBubble = memo(DocumentStatusBubble);
export { MemoDocumentStatusBubble as DocumentStatusBubble };
